import { render, staticRenderFns } from "./DashboardShipments.vue?vue&type=template&id=67986459&scoped=true"
import script from "./DashboardShipments.vue?vue&type=script&lang=js"
export * from "./DashboardShipments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67986459",
  null
  
)

export default component.exports